



















































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import {
	OrgsApi,
	Product,
	Site,
	User,
	PartnerApi,
	Audit,
	ProductStatus,
	Address,
	UsersApi,
} from '../../../api';
import Toast from '@/components/display/toast.vue';
import TitleMixin from '@/mixins/title-mixin';
import addOrgAdmin from '@/components/add business objects/addOrgAdmin.vue';
import addBilling from '@/components/add business objects/addBilling.vue';
import BillingTab from './billing/BillingTab.vue';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import productSuggest from '@/components/form pickers/productSuggest.vue';
import UsersTable from '@/components/tables/users-table.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import tableSearchBar from '@/components/elements/fillables/table-search-bar.vue';
import InformationRow from '@/components/display/information-row.vue';
import OrgAddressSearch from './components/OrgAddressSearch.vue';
import { OrgService } from '@/services/org-service';
import { OrgExtended, SiteExtended } from '@/models/extensions';
import AddUserForm from '@/components/add business objects/add-user/AddUserForm.vue';
import { ApiUtils } from '@/common/ApiUtils';

import HubSpotLink from '@/components/display/HubSpotLink.vue';
import ErrorDiv from '@/components/display/errorDiv.vue';
import { ParsingUtil } from '@/common/ParsingUtil';
import ChangelogLink from '@/components/display/changelog-link.vue';
import { StatusUtil } from '@/util/status-util';

@Component({
	components: {
		ChangelogLink,
		ErrorDiv,
		InformationRow,
		secondaryNav,
		addOrgAdmin,
		addBilling,
		BillingTab,
		routerLinkButton,
		productSuggest,
		UsersTable,
		infoTabs,
		tableSearchBar,
		OrgAddressSearch,
		AddUserForm,
		HubSpotLink,
	},
	mixins: [TitleMixin],
})
export default class OrganisationView extends Vue {
	public loading = true;
	public org: OrgExtended | null = null;
	public sites: SiteExtended<Address>[] | null = [];
	public users: User[] | null = [];
	public audits: Audit[] | null = null;
	public subscriptionAudits: Audit[] | null = null;
	public termsUser: User | null = null;
	public termsDate: string | null = null;
	public allPartnerProducts: Product[] | undefined = [];
	public partnerProducts: Product[] | undefined = [];
	public selectedProduct = {
		id: '',
		name: '',
		type: '',
		status: '',
		supplierNumber: '',
	};

	public productList: Product[] = [];

	public partnerRoles = [
		{ value: 'partner.admin', text: 'Admin' },
		{ value: 'partner.user', text: 'Read Only' },
	];

	public productFields: any[] | null = [
		{ key: 'id', label: 'Id', sortable: true },
		{ key: 'type', label: 'Type', sortable: true },
		{ key: 'name', label: 'Name', sortable: true },
		{ key: 'status', label: 'Status', sortable: true },
		{ key: 'supplierNumber', label: 'Supplier Number', sortable: true },
		{ key: 'milkCompanyName', label: 'Milk Company', sortable: true },
		{ key: 'site.name', label: 'Site', sortable: true },
	];

	public siteFields: any[] | null = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{ key: 'address.fullAdr', label: 'Address' },
		{ key: 'address.region', label: 'Region' },
	];

	public auditFields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public subscriptionAuditFields: any[] | null = [
		// {key: 'id', label: 'ID'},
		{ key: 'created_at', label: 'Date Sent', sortable: true },
		{ key: 'old_values', label: 'From', sortable: true },
		{ key: 'new_values', label: 'To', sortable: true },
		{ key: 'user.name', label: 'By', sortable: true },
	];

	public partnerProductFields: any[] | null = [
		// {key: 'id', label: 'ID'},['id','type','name','status','supplierNumber','remove']
		{ key: 'id', label: 'Id', sortable: true },
		{ key: 'type', label: 'Type', sortable: true },
		{ key: 'name', label: 'Name', sortable: true },
		{ key: 'status', label: 'Status', sortable: true },
		{ key: 'contributionTier', label: 'Contribution Tier', sortable: true },
		{ key: 'partnerDefinedId', label: 'Id Label', sortable: true },
		{ key: 'partnerDefinedName', label: 'Name Label', sortable: true },
		{ key: 'remove', label: 'Remove' },
	];

	public markers: any[] = [];

	public orgId?: number | null;
	public orgError?: string = '';

	public grid: boolean = true;

	get currentOrgId(): number | null {
		return this.orgId ?? ParsingUtil.parseId(this.$route.params.orgId);
	}

	get isBillingOrg(): boolean {
		return this.org?.orgType === 'billing';
	}

	private orgService: OrgService = new OrgService();

	public pageTitle() {
		return `org | ${this.org?.name ?? ''}`;
	}

	public clearSelectedProduct() {
		this.selectedProduct = {
			id: '',
			name: '',
			type: '',
			status: '',
			supplierNumber: '',
		};
	}

	public async load() {
		if (this.orgId == null) {
			this.loading = false;
			this.orgError = `Failed to load org for ID '${this.$route.params.orgId}'`;
			return;
		}

		const { org, errorMessage } = await this.orgService.getOrgById<OrgExtended>(
			this.orgId,
			[
				'admin',
				'products',
				'products.vats',
				'products.site',
				'products.vats.site',
				'sites',
				'sites.address',
				'address',
				'audits',
				'audits.user',
				'subscription',
				'subscription.audits',
				'subscription.audits.user',
			],
			{
				'fields[admin]': 'id,name,email,phone',
				'fields[vats]': 'id,productId,siteId,label,model',
				'fields[sites]': 'id,name,orgId',
			},
		);
		if (!org || errorMessage) {
			console.error('Error loading org:', errorMessage ?? 'Unknown error, no org found');
			this.org = null;
			this.orgError = errorMessage ?? 'Unknown error, no org found';
			this.loading = false;
			return;
		}
		this.org = org;
		this.productList =
			this.org.products
				?.sort((a, b) => (a?.id ?? 0) - (b?.id ?? 0))
				?.sort((a, b) => StatusUtil.getPriority(a.status) - StatusUtil.getPriority(b.status)) ?? [];
		this.org.admin = org.admin || { id: 0, name: '', firstName: '', lastName: '', email: '' };
		this.sites = org.sites || [];
		this.audits = org.audits || [];
		this.subscriptionAudits = org.subscription?.audits || [];
		this.org.subscription = org.subscription || { id: 0 };

		if (this.org.address && this.org.address.latitude && this.org.address.longitude) {
			this.markers.push({
				position: {
					lat: parseFloat(this.org.address.latitude),
					lng: parseFloat(this.org.address.longitude),
				},
			});
		}

		await this.loadUsers();
		await this.setTermsAndConditionsInfo();
		await this.loadPartnerProducts();
	}

	public async loadPartnerProducts() {
		if (this.orgId == null) return;

		const { products, errorMessage } = await this.orgService.getOrgPartnerProducts(this.orgId);
		if (!products || errorMessage) {
			this.partnerProducts = undefined;
			console.error(errorMessage ?? 'Unknown error, no products found');
			return;
		}
		this.allPartnerProducts = products;
		this.partnerProducts = products;
	}

	public async addPartnerProduct() {
		if (this.org?.id == null || this.selectedProduct?.id == null) {
			new Toast().makeToast(
				'Failed to add partner product, no org or selected product ID found',
				'Error Adding Partner Product',
				'danger',
				true,
			);
			return;
		}
		try {
			await new PartnerApi().partnerAddProduct(this.org.id, {
				data: { productId: parseInt(this.selectedProduct.id) },
			});
		} catch (e) {
			new Toast().makeToast(e, 'Error Adding Partner Product', 'danger', true);
		}
		await this.load();
	}

	public async removePartnerProduct(partnerProduct: { name: any; id: any }) {
		if (this.org?.id == null) {
			new Toast().makeToast(
				'Failed to remove partner product, no org ID found',
				'Error Removing Partner Product',
				'danger',
				true,
			);
			return;
		}
		if (confirm(`Are you sure you wish to remove the ${partnerProduct.name} partner product?`)) {
			try {
				await new PartnerApi().partnerRemoveProduct(this.org.id, {
					data: { productId: partnerProduct.id },
				});
			} catch (e) {
				new Toast().makeToast(e, 'Error Removing Partner Product', 'danger', true);
			}
			await this.load();
		} else {
			return;
		}
	}

	public async loadUsers() {
		if (this.org?.id == null) {
			new Toast().makeToast(
				'Failed to load users, no org ID found',
				'Error Loading Users',
				'danger',
				true,
			);
			return;
		}

		const { users, errorMessage } = await this.orgService.getOrgUsers(this.org.id);
		if (!users || errorMessage) {
			new Toast().makeToast(
				errorMessage ?? 'Unknown error, no users found',
				'Error Loading Users',
				'danger',
				true,
			);
			return;
		}
		try {
			const api = new OrgsApi();
			const response = await api.getOrgUsers(this.org.id);
			this.users = response.data.data || [];
		} catch (e) {
			new Toast().makeToast(e, 'Error Loading Users', 'danger', true);
		}
	}

	public async terms() {
		if (this.org?.id == null) {
			new Toast().makeToast(
				'Failed to accept terms, no org ID found',
				'Error Accepting Terms',
				'danger',
				true,
			);
			return;
		}
		const { errorMessage } = await this.orgService.acceptTerms(this.org.id);
		if (errorMessage) {
			new Toast().makeToast(errorMessage, 'Error Accepting Terms', 'danger', true);
			return;
		}
		new Toast().makeToast('Terms Accepted', 'Job Created', 'success');
	}

	public async deleteOrg() {
		if (!this.org) return;

		const liveProducts = this.org.products?.filter(
			product =>
				product.status &&
				![ProductStatus.Removed, ProductStatus.Cancelled].includes(product.status),
		);
		let confirmMessage = null;
		if (liveProducts && liveProducts?.length > 0)
			confirmMessage = `products ${liveProducts.map(
				product => `\n${product.name} : ${product.status}`,
			)}`;
		else if (this.users && this.users.length > 0)
			confirmMessage = `all users ${this.users.map(user => `\n${user.name} : ${user.id}`)}`;
		else if (this.sites && this.sites.length > 0)
			confirmMessage = `all sites ${this.sites.map(site => `\n${site.name} : ${site.status}`)}`;
		if (confirmMessage) {
			new Toast().makeToast(confirmMessage, 'Action Required Before Deleting Org', 'warn', true);
			return;
		}

		if (this.org?.id && confirm(`Are you sure you wish to delete org ${this.org.name}`)) {
			const { errorMessage } = await this.orgService.deleteOrg(this.org.id);
			if (errorMessage) {
				new Toast().makeToast(errorMessage, 'Error Deleting Org', 'danger', true);
				return;
			}
			new Toast().makeToast(
				'You have deleted Org ' + this.org.name,
				'Success Deleting Org ' + this.org.id,
				'success',
				true,
			);

			await this.$router.push({
				name: `organisations.list`,
			} as any);
		}
	}

	public async job() {
		if (!this.org?.id) return;

		const { errorMessage } = await this.orgService.orgInstallJob(this.org.id);
		if (errorMessage) {
			new Toast().makeToast(errorMessage, 'Error Creating Job', 'danger', true);
			return;
		}
		new Toast().makeToast('Installer Job', 'Job Created', 'success');
	}

	public async setTermsAndConditionsInfo(): Promise<void> {
		if (!this.org?.latestSignedTerms) {
			return;
		}
		try {
			const userResponse = await new UsersApi().getUserId(this.org.latestSignedTerms.userId);
			this.termsUser = userResponse.data;
			this.termsDate = this.org.latestSignedTerms.dateSigned;
		} catch (e) {
			const error = ApiUtils.handleApiError(
				e,
				'There was a problem loading the terms and conditions user',
			);
			new Toast().makeToast(
				error.errorMessage,
				'Failed to fetch terms and conditions user',
				'danger',
			);
		}
	}

	public async created() {
		this.orgId = ParsingUtil.parseId(this.$route.params.orgId);
		await this.load();

		this.$watch(
			() => this.$route.params.orgId,
			async (to, from) => {
				this.orgId = ParsingUtil.parseId(to) ?? this.orgId;
				await this.load();
			},
		);
	}

	public get getOrgTermsVersion(): string | null | undefined {
		return this.org?.latestSignedTerms?.terms?.version;
	}

	public get ordwayBaseUrl(): string {
		return process.env.VUE_APP_ORDWAY_BASE_URL;
	}

	public filterProducts(productList: any[]) {
		this.productList =
			productList
				?.sort((a, b) => (a?.id ?? 0) - (b?.id ?? 0))
				?.sort((a, b) => StatusUtil.getPriority(a.status) - StatusUtil.getPriority(b.status)) ?? [];
	}
}
